export default "__VITE_ASSET__D61Zi2Mj__"